var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWayRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 0,
    width: 36,
    height: 26,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,72,0)",
    clipPath: "url(#master_svg0_24_05207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246468525851679e-16,-1.2246468525851679e-16,-1,144,24.998840332031243)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 11.999420166015625,
    x2: 107.29644775390625,
    y2: 11.999420166015625,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.411934125,12.995223828125L49.702778125,0.700420828125L48.995578125,-0.006573171875000006L35.998222125,12.994923828125L48.995378125,26.006423828125L49.702878125,25.299723828125L37.411934125,12.995223828125Z",
    fillRule: "evenodd",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayRight);
export default __webpack_public_path__ + "static/media/way-right.9ed178f32c7073f9584c6b7f4540e68f.svg";
export { ForwardRef as ReactComponent };